import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSharedService {

  constructor() { }
  private firstNameSource = new BehaviorSubject<string>('');
  firstName$ = this.firstNameSource.asObservable();

  setFirstName(name: string): void {
    this.firstNameSource.next(name);
  }
}
